/**
 * Announcement Banner Configuration
 *
 * Easy way to manage site-wide announcements.
 * Simply update these values to show/hide and customize the banner.
 *
 * The banner automatically shows different messages based on wallet connection status:
 * - notConnectedMessage: Shown when no wallet is connected
 * - connectedMessage: Shown when a wallet is connected
 *
 * Changes are reflected immediately on all pages.
 */

export interface AnnouncementConfig {
  /** Show the announcement banner (true = visible, false = hidden) */
  enabled: boolean;

  /** Message to display when no wallet is connected */
  notConnectedMessage: string;

  /** Message to display when a wallet is connected */
  connectedMessage: string;

  /** Banner type: "info" | "success" | "warning" | "critical" */
  type: "info" | "success" | "warning" | "critical";
}

/**
 * Current announcement configuration
 *
 * QUICK START - To show an announcement:
 * 1. Set enabled: true
 * 2. Update notConnectedMessage and connectedMessage
 * 3. Choose type: "info" | "success" | "warning" | "critical"
 *
 * The banner automatically switches between messages based on wallet connection.
 *
 * To HIDE the banner, set enabled: false
 */
export const ANNOUNCEMENT_CONFIG: AnnouncementConfig = {
  enabled: false,
  type: "info",
  notConnectedMessage: "🌍 The biggest Suikamon update is in progress — more wallets, more game modes, the world is growing. Stay tuned!",
  connectedMessage: "🌍 The biggest Suikamon update is in progress — more wallets, more game modes, the world is growing. Stay tuned!",
};
